import { render, staticRenderFns } from "./OrientationWidget.vue?vue&type=template&id=0a868bf0&scoped=true&"
import script from "./OrientationWidget.vue?vue&type=script&lang=js&"
export * from "./OrientationWidget.vue?vue&type=script&lang=js&"
import style0 from "./OrientationWidget.vue?vue&type=style&index=0&id=0a868bf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a868bf0",
  null
  
)

export default component.exports